import { atom } from 'recoil'
import { RootLoaders } from 'src/types'

export const atomRootLoaders = atom<RootLoaders>({
  key: 'rootLoaders',
  default: {},
})
